

/**
 * event listener for product tile view change button
 * @param {*} e
 */
const handleTileView = function (e) {
  const self = e.currentTarget;
  const viewBtnGroup = document.getElementById("v-btn-group");
  const productTiles = document.querySelectorAll(".product-tile");

  Array.from(viewBtnGroup.children).forEach(viewBtn => {
    viewBtn.classList.remove("active");
  });

  self.classList.add("active");

  if (self.id === "v-btn--grid") {
    productTiles.forEach(productTile => {
      productTile.classList.remove("product-tile--slist");
      productTile.classList.remove("product-tile--list");
    });
  }
  else if (self.id === "v-btn--list") {
    productTiles.forEach(productTile => {
      productTile.classList.remove("product-tile--slist");
      productTile.classList.add("product-tile--list");
    });
  }
  else if (self.id === "v-btn--slist") {
    productTiles.forEach(productTile => {
      productTile.classList.remove("product-tile--list");
      productTile.classList.add("product-tile--slist");
    });
  }
};

/**
 * function to assign product tile view change button event handler
 */
export function initTileViewBtn() {
  const viewBtnGroup = document.getElementById("v-btn-group");
  Array.from(viewBtnGroup.children).forEach(viewBtn => {
    viewBtn.onclick = handleTileView;
  });
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-header/tileView.js